import React, { useState } from 'react';
import getCancelToken from '../../util/axios';
import axios from 'axios';
import LoadButton from './LoadButton';
import useLoadingForm from '../../hooks/loadingFormHook';
import Dropdown from '../dropdown/Dropdown';

import '../../styles/dashboard/DashboardMessaging.css';

export default function DashboardMessaging({ history }) {
    const [cancelMessageToken, setCancelMessageToken] = useState(getCancelToken());
    // The function that we wait for
    const submitHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500", {
            cancelToken: cancelMessageToken.token
        });
    };

    // Callback for when loading function ends
    const submitCallback = (data) => {
        // history.push('/dashboard');
    };

    const messagingFormRules = {
        listing: [{
            test: (value) => value.length,
            errorMsg: 'This is a required field'
        }],
        message: [{
            test: (value) => value.length,
            errorMsg: 'This is a required field'
        }]
    };

    const { formData, setFormData, handleChange, loading, loaded, setLoaded, errorMapping, handleSubmit } = useLoadingForm({
        listing: '',
        message: ''
    }, submitHandler, submitCallback, null, messagingFormRules);

    const handleDropdownChange = (item) => {
        if (loaded) {
            setLoaded(false);
        }

        setFormData({...formData, listing: item});
    };

    return (
        <div className="DashboardMessaging">
            <div className="header">
                <h1>Bulk Messaging</h1>
                <p>Bulk message people who liked your listing!</p>
            </div>
            <div className="content">
                <form 
                className="formDashboard"
                onSubmit={handleSubmit}>
                    <Dropdown 
                    items={["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6", "Item 7", "Item 8"]}
                    handleChange={handleDropdownChange}
                    errorText={errorMapping.listing}
                    loading={loading} />
                    <textarea 
                    className={errorMapping.message && 'form-error-input'}
                    name="message"
                    placeholder="Enter a message"
                    value={formData.message}
                    onChange={handleChange} />
                    {errorMapping.message && <p className="form-error">{errorMapping.message}</p>}
                    <LoadButton 
                    loading={loading}
                    loaded={loaded}
                    defaultText="Send Bulk Message"
                    loadingText="4/28 Messaged"
                    loadedText="Message Sent"
                    theme="black" />
                </form>
                <button 
                className={loading ? "secondary-button" : "disabled-button"}
                onClick={(e) => {
                    if (loading) {
                        cancelMessageToken.cancel();
                        setCancelMessageToken(getCancelToken());
                    }
                }}>Stop Messaging</button>
            </div>
            <p className="disclaimer">DISCLAIMER! Depop is highly against spam. 
            Try to switch up your messages often and do not overuse this feature to 
            ensure you aren’t flagged for spam</p>
        </div>
    )
}